import axios from 'axios'
import ModalMixin from '@/mixins/ModalMixin.js'

export default {
  mixins: [ModalMixin],
  methods: {
    openBoxMixinFn(deliveryRequestId, token) {
      // INFO: openBox, na podstawie DR wywoluje, open_box
      // Zwrotka: DR z box_id, zapisujemy je do storage
      this.$blockUI()

      // if (this.$dev) {
      //   this.$unblockUI()
      //   window.localStorage.setItem('box_id', '8ed6e096-17fb-4518-a879-9ea2629934c1')
      //   this.$router.push(`/delivery/delivery-request/${deliveryRequestId}/confirmation`)
      //   return
      // }

      axios({
        method: 'put',
        url: `/delivery_requests/${deliveryRequestId}/open_box`,
        headers: {
          common: {
            Authorization: `Bearer ${token}`
          }
        }
      })
        .then((response) => {
          window.localStorage.setItem('box_id', response.data.boxId)
          this.$router.push(
            `/delivery/delivery-request/${deliveryRequestId}/confirmation`
          )
        })
        .catch((error) => {
          let errorCode = Object.values(
            (((error || {}).response || {}).data || {}).errors
          )
          if (errorCode == 'dr:9') {
            this.openCloseLockerPromptModal(this.$t('CLOSE_LOCKER_MESSAGE_A'), () => {
              this.openBoxMixinFn(deliveryRequestId, token)
            })
          } else if (errorCode == 'dr:10') {
            this.openNoAvailableBoxesModal()
          } else {
            this.$errorHumanized(error)
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    }
  }
}
